<script setup>
const route = useRoute();
const { data, error } = await useCmsFetch(`entry/${route.params.slug}`);

const { setGlobalTheme } = useTheme();
setGlobalTheme(data.value.theme);

const { breadcrumbs } = useTTCState();

onMounted(() => {
  breadcrumbs.value = data.value.breadcrumbs;
});

onBeforeUnmount(() => {
  breadcrumbs.value = null;
});

const { isMobileOrTablet } = useDevice();
const { width: innerWidth } = useWindowSize();

const isMobile = computed(() => {
  if (process.server) return isMobileOrTablet;
  return innerWidth.value < 900;
});

useHead({
  title: data.value?.seoTitle + " | .the tech collective",

  meta: [
    { property: "og:title", content: data.value?.seoTitle },
    { name: "image", property: "og:image", content: data.value?.seoImage },
    { name: "description", content: data.value?.seoDescription },
    { name: "robots", content: data.value?.seoRobots },
  ],
  link: [
    {
      rel: "canonical",
      href: data.value?.seoCanonical || useRequestURL().href,
    },
  ].filter((item) => item.href),
});
</script>

<template>
  <div v-if="data">
    <section-hero-insight
      :heading="data.meta.teaserTitle || data.title"
      :body="data.meta.teaserDescription"
      :media="data.meta.media"
      :cta="data.cta"
      :post-date="data.meta.postDate"
      :parent="data.meta.parent"
      :text-color="data.textColor.value"
      :gated-content="data.gatedContent"
    />
    <component-insight-sections
      v-if="data"
      :sections="data.insightSections"
      :is-insight="true"
      :insight-data="data"
    />
    <component-sections v-if="data" :sections="data.sections" />
    <!-- <code>
      <pre>{{ data }}</pre>
    </code> -->
  </div>
</template>

<style></style>
